module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-kultur-genuss"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Kultur & Genuss")]), _vm._v("\n            in Kulmbach!\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-6"
  }, [_c('h2', [_vm._v("Eine runde Sache für „Bierologen“!")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankunft am Bahnhof Kulmbach")]), _vm._v(" "), _c('li', [_vm._v("Spaziergang zum Kulmbacher Mönchshof (Dauer 15 Min.)")]), _vm._v(" "), _c('li', [_vm._v("Besuch des Bayerischen Brauereimuseums (Dauer 90 Min.)")]), _vm._v(" "), _c('li', [_vm._v("Einkehr bei Zissel mit Bierprobe, Zapferprüfung und Biermenü (Open end)")]), _vm._v(" "), _c('li', [_vm._v("Der Zissel-Wirt führt Sie humorvoll durch die Bierprobe.\n                            Sie erfahren einiges über Bier und seine Herstellung.")])]), _vm._v(" "), _c('div', {
    staticClass: "infobox"
  }, [_c('h3', [_vm._v("Sie trinken:")]), _vm._v(" "), _c('p', [_vm._v("\n                            Das stärkste Bier der Welt sowie Zissel Hell, Zissel Dunkel,\n                            Zissel Rauch und unsere neuen Mixgetränke. Das Bier-Probier-Glas dürfen Sie mitnehmen.\n                            Dazu empfehlen wir unser Original Kulmbacher Bierfleisch.\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col sm-6"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/kultur-genuss-content.jpg",
      "alt": "Brauereiführung"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b373f7cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/kultur-genuss.vue
// module id = 34
// module chunks = 0